import React, {MouseEvent} from "react";
import {GridCellAttachment} from "ts/api/task";
import FlexBox from "view/components/Layout/FlexBox";
import CellFileAttachment from "view/components/GridResponseBlock/CustomizeTable/Components/Rows/Cell/FilesResponseInput/components/CellFileAttachment";
import {AttachmentFile, RawAttachmentFile} from "ts/api/attachmentFile";

type CellAttachmentListProps = {
  onDelete: (id: string) => () => void;
  fileUrls?: Record<string, string>;
  attachments: GridCellAttachment[];
  viewOnly?: boolean;
  onClick: (
    attachment: RawAttachmentFile | AttachmentFile
  ) => (e: MouseEvent) => void;
};

const CellAttachmentList = ({
  onDelete,
  attachments,
  fileUrls,
  viewOnly,
  onClick,
}: CellAttachmentListProps) => {
  if (!attachments.length) {
    return null;
  }
  return (
    <FlexBox width="100%" gap={1} flexDirection="column" alignCenter>
      {attachments.map((attachment) => (
        <CellFileAttachment
          key={attachment.id}
          file={{
            ...attachment,
            url: (fileUrls
              ? fileUrls[attachment.id]
              : attachment.url) as string,
          }}
          onDelete={() => onDelete(attachment.id)}
          viewOnly={viewOnly}
          onClick={onClick(attachment)}
        />
      ))}
    </FlexBox>
  );
};

export default CellAttachmentList;
